<script lang="ts">
	export let hover = false;
	export let left = false;

</script>

<svg
	class:hover
	xmlns="http://www.w3.org/2000/svg"
	viewBox="0 0 15.603 13.93"
	class:left>
	<g>
		<g>
			<path
				d="M71.57 90.4a.3.3 0 0 1-.214-.087.312.312 0 0 1-.007-.439l6.178-6.438-6.178-6.439a.312.312 0 0 1 .007-.439.306.306 0 0 1 .436.007l6.385 6.655a.312.312 0 0 1 0 .432L71.792 90.3a.308.308 0 0 1-.222.1z"
				transform="translate(-62.66 -76.467)" />
		</g>
		<g>
			<path
				d="M59.039 98.51H44.058a.308.308 0 1 1 0-.616h14.981a.308.308 0 1 1 0 .616z"
				transform="translate(-43.747 -91.237)" />
		</g>
	</g>
</svg>

<style lang="scss">
	svg {
		&.left {
			transform: rotate(180deg);
		}

		path {
			fill: #3c68d6;
			transition: fill 0.5s;
		}

		&.hover {
			path {
				fill: var(--default-hover-btn-1);
			}
		}
	}

</style>
